import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiPhone, FiMail, FiMapPin } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import styles from './Contact.module.css';

const WHATSAPP = 'https://wa.me/16726676878?text=Hi%20Murat%2C%20I%20would%20like%20to%20book%20an%20oil%20change%20service.';

export default function Contact() {
  const { t } = useTranslation();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.15 });

  const items = [
    { icon: <FiPhone size={20}/>, label: t('contact.phone'), val: '672-667-6878', href: 'tel:+16726676878' },
    { icon: <FiMail size={20}/>, label: t('contact.email'), val: 'muratbulum@gmail.com', href: 'mailto:muratbulum@gmail.com' },
    { icon: <FaWhatsapp size={20}/>, label: t('contact.whatsapp'), val: t('contact.whatsappVal'), href: WHATSAPP, green: true },
    { icon: <FiMapPin size={20}/>, label: t('contact.serviceArea'), val: t('contact.serviceAreaVal'), href: null },
  ];

  return (
    <section id="contact" className={styles.section} ref={ref}>
      <div className={styles.container}>
        <motion.div className={styles.header}
          initial={{ opacity: 0, y: 24 }} animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}>
          <span className={styles.label}><span className={styles.labelLine}/> {t('contact.label')}</span>
          <h2 className={styles.heading}>{t('contact.heading').split('Murat Bulum')[0]}<span className={styles.accent}>Murat Bulum</span></h2>
          <p className={styles.sub}>{t('contact.sub')}</p>
        </motion.div>

        <div className={styles.grid}>
          {items.map((item, i) => (
            <motion.div key={item.label}
              initial={{ opacity: 0, y: 24 }} animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.15 + i * 0.1 }}>
              {item.href ? (
                <a href={item.href} target={item.green ? '_blank' : undefined} rel="noreferrer"
                  className={`${styles.card} ${item.green ? styles.cardGreen : ''}`}>
                  <div className={`${styles.iconWrap} ${item.green ? styles.iconGreen : ''}`}>{item.icon}</div>
                  <div>
                    <span className={styles.cardLabel}>{item.label}</span>
                    <span className={styles.cardVal}>{item.val}</span>
                  </div>
                </a>
              ) : (
                <div className={styles.card}>
                  <div className={styles.iconWrap}>{item.icon}</div>
                  <div>
                    <span className={styles.cardLabel}>{item.label}</span>
                    <span className={styles.cardVal}>{item.val}</span>
                  </div>
                </div>
              )}
            </motion.div>
          ))}
        </div>

        <motion.div className={styles.cta}
          initial={{ opacity: 0, y: 20 }} animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.5 }}>
          <p>{t('contact.ctaText')}</p>
          <a href={WHATSAPP} target="_blank" rel="noreferrer" className={styles.waBtn}>
            <FaWhatsapp size={22}/> {t('contact.openWhatsapp')}
          </a>
        </motion.div>
      </div>
    </section>
  );
}
